<profile-section class="intro-section">
  <ng-container slot="title" i18n>Mes souhaits</ng-container>

  <ng-container slot="main">
    <div class="wishes" *ngFor="let wish of model; trackBy: trackByWish">
      <span class="wishes__period">
        <profile-i18n-wishes [model]="wish.when"></profile-i18n-wishes>
      </span>
      <p class="wishes__description">{{ wish.description }}</p>
    </div>
  </ng-container>
</profile-section>
